import { useLayoutEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { MDSTypography } from '@marqvision/mds-v2';
import { MDSButton } from '@marqvision/mds/core';
import { IcoArrowDownOutline, IcoArrowUpOutline } from '@marqvision/mds/assets';
import { AutoLink } from './AutoLink';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
  },
  text: {
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
  },
});

const textMaxHeight = 'calc(1em * 1.5 * 10)'; // 1.5 lineHeight * 10 lines

type Props = {
  data: string;
};

export const DetailContentBox = (props: Props) => {
  const { data } = props;
  const classes = useStyles();

  const textRef = useRef<HTMLParagraphElement>(null);
  const [isHideExpand, setIsHideExpand] = useState(false);
  const [isShowAll, setIsShowAll] = useState<boolean>(false);

  const toggleShowAll = () => {
    setIsShowAll((prev) => !prev);
  };

  useLayoutEffect(() => {
    setIsHideExpand(!!textRef.current && textRef.current.scrollHeight <= textRef.current.offsetHeight);
  }, []);

  return (
    <div className={classes.wrapper}>
      <MDSTypography as="div" variant="T14">
        <p
          ref={textRef}
          className={classes.text}
          style={{ maxHeight: !isShowAll ? textMaxHeight : undefined }}
        >
          <AutoLink sliceLength={50} text={data} />
        </p>
        {!isHideExpand && !isShowAll && <span>...</span>}
      </MDSTypography>

      {!isHideExpand && (
        <MDSButton
          variant="text"
          color="bluegray"
          size="medium"
          endIcon={isShowAll ? <IcoArrowUpOutline /> : <IcoArrowDownOutline />}
          onClick={toggleShowAll}
        >
          {isShowAll ? 'Show less' : 'Show more'}
        </MDSButton>
      )}
    </div>
  );
};